import React, { useRef } from 'react';
import { content } from '../data/content';
import { gsap, useGSAP } from '../lib/gsap';
import { useReveal } from '../hooks/useReveal';

const Experience = ({ language }) => {
    const t = content[language].experience;
    const root = useRef(null);
    const listRef = useRef(null);
    const lineRef = useRef(null);

    useReveal(root);

    // Draw the timeline rail as you scroll the list.
    useGSAP(() => {
        const mm = gsap.matchMedia();
        mm.add('(prefers-reduced-motion: no-preference)', () => {
            gsap.fromTo(
                lineRef.current,
                { scaleY: 0 },
                {
                    scaleY: 1,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: listRef.current,
                        start: 'top 70%',
                        end: 'bottom 80%',
                        scrub: true,
                    },
                }
            );
        });
        mm.add('(prefers-reduced-motion: reduce)', () => {
            gsap.set(lineRef.current, { scaleY: 1 });
        });
        return () => mm.revert();
    }, { scope: root });

    return (
        <div ref={root} className="min-h-screen pt-24 pb-16 px-4 container mx-auto">
            <h1 className="reveal text-4xl font-bold text-center mb-12 text-gray-800 dark:text-white">
                {t.title}
            </h1>

            <div ref={listRef} className="relative max-w-3xl mx-auto">
                <span
                    ref={lineRef}
                    className="absolute left-2 top-3 bottom-3 w-0.5 bg-blue-500/40 origin-top"
                    aria-hidden="true"
                />
                <div className="space-y-8">
                    {t.items.map((exp, index) => (
                        <div key={index} className="reveal-card relative pl-10">
                            <span className="absolute left-0 top-4 w-4 h-4 rounded-full bg-blue-500 border-4 border-white dark:border-gray-900" aria-hidden="true" />
                            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
                                <div className="flex flex-col md:flex-row md:justify-between md:items-start mb-4">
                                    <div>
                                        <h3 className="text-xl font-bold text-gray-800 dark:text-white">{exp.title}</h3>
                                        <p className="text-blue-600 dark:text-blue-400 font-medium">{exp.company}</p>
                                        <p className="text-gray-500 dark:text-gray-400 text-sm">{exp.dept}</p>
                                    </div>
                                    <span className="inline-block mt-2 md:mt-0 px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm text-gray-600 dark:text-gray-300 whitespace-nowrap">
                                        {exp.period}
                                    </span>
                                </div>
                                <ul className="space-y-2">
                                    {exp.details.map((detail, i) => (
                                        <li key={i} className="flex items-start gap-2 text-gray-700 dark:text-gray-300">
                                            <span className="mt-1.5 w-1.5 h-1.5 bg-blue-500 rounded-full flex-shrink-0"></span>
                                            <span>{detail}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Experience;
